import validator from "validator";

const isEmail = (value) => value && !validator.isEmail(value) && "Invalid email";

export default isEmail;
